var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "DialogBase",
        {
          attrs: {
            visible: _vm.isOpen,
            "close-on-click-modal": false,
            width: "70%",
            top: "80px",
            title: "Danh sách học sinh",
            "panel-icon": "el-icon-school",
            "panel-title": "Danh sách học sinh",
            "panel-subtitle":
              "Chọn lớp và tìm kiếm học sinh áp dụng tin tức này",
            "confirm-text": "Xác nhận",
            "cancel-text": "Hủy bỏ",
          },
          on: {
            "before-close": _vm.handleClose,
            cancel: _vm.handleClose,
            confirm: _vm.handleSaveForm,
          },
        },
        [
          _c("div", { staticClass: "body_dialog" }, [
            _c(
              "div",
              { staticClass: "ksf-filter-bar" },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 12, type: "flex", align: "bottom" } },
                  [
                    _c("el-col", { attrs: { span: 8 } }, [
                      _c(
                        "div",
                        { staticClass: "ksf-filter-item" },
                        [
                          _c("span", { staticClass: "ksf-filter-label" }, [
                            _c("i", { staticClass: "el-icon-folder-opened" }),
                            _vm._v(" Lớp áp dụng"),
                          ]),
                          _c(
                            "el-select",
                            {
                              staticClass: "ksf-select",
                              staticStyle: { width: "100%" },
                              attrs: {
                                multiple: "",
                                filterable: "",
                                "allow-create": "",
                                "default-first-option": "",
                                placeholder: "Chọn lớp",
                              },
                              on: { change: _vm.handleChangeFilter },
                              model: {
                                value: _vm.classesApply,
                                callback: function ($$v) {
                                  _vm.classesApply = $$v
                                },
                                expression: "classesApply",
                              },
                            },
                            _vm._l(_vm.classOptions, function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.className,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm.classesApply.length > 0
                      ? _c("el-col", { attrs: { span: 8 } }, [
                          _c(
                            "div",
                            { staticClass: "ksf-filter-item" },
                            [
                              _c("span", { staticClass: "ksf-filter-label" }, [
                                _c("i", { staticClass: "el-icon-info" }),
                                _vm._v(" Trạng thái học sinh"),
                              ]),
                              _c(
                                "el-select",
                                {
                                  staticClass: "ksf-select",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    multiple: "",
                                    filterable: "",
                                    placeholder: "Chọn trạng thái",
                                  },
                                  on: { change: _vm.handleChangeFilter },
                                  model: {
                                    value: _vm.statusKidsApply,
                                    callback: function ($$v) {
                                      _vm.statusKidsApply = $$v
                                    },
                                    expression: "statusKidsApply",
                                  },
                                },
                                _vm._l(_vm.statusList, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.value,
                                      value: item.key,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm.classesApply.length > 0
                      ? _c("el-col", { attrs: { span: 8 } }, [
                          _c(
                            "div",
                            { staticClass: "ksf-filter-item" },
                            [
                              _c("span", { staticClass: "ksf-filter-label" }, [
                                _c("i", { staticClass: "el-icon-user" }),
                                _vm._v(" Tìm kiếm học sinh"),
                              ]),
                              _c("el-input", {
                                staticClass: "ksf-input-search",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  clearable: true,
                                  placeholder: "Nhập tên học sinh tìm kiếm...",
                                },
                                on: {
                                  change: _vm.handleChangeFilter,
                                  clear: _vm.handleChangeFilter,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "append",
                                      fn: function () {
                                        return [
                                          _c("el-button", {
                                            attrs: { icon: "el-icon-search" },
                                            on: {
                                              click: _vm.handleChangeFilter,
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  1853576214
                                ),
                                model: {
                                  value: _vm.nameKids,
                                  callback: function ($$v) {
                                    _vm.nameKids = $$v
                                  },
                                  expression: "nameKids",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                class: [
                  "ksf-list-wrapper",
                  { "no-data": _vm.kidsDataFilter.length === 0 },
                ],
              },
              [
                _vm.kidsDataFilter.length > 0
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "ksf-list-header" },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { indeterminate: _vm.isIndeterminate },
                              on: { change: _vm.handleCheckAllChange },
                              model: {
                                value: _vm.checkAll,
                                callback: function ($$v) {
                                  _vm.checkAll = $$v
                                },
                                expression: "checkAll",
                              },
                            },
                            [
                              _vm._v(
                                "\n              Tất cả học sinh\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "ksf-scroll-area" },
                        _vm._l(_vm.kidsDataFilter, function (item) {
                          return _c(
                            "div",
                            {
                              key: item.idClass,
                              staticClass: "ksf-class-group",
                            },
                            [
                              _c(
                                "el-divider",
                                { attrs: { "content-position": "left" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "ksf-class-divider-label" },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-star-on",
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "title_group" },
                                        [_vm._v(_vm._s(item.className))]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "el-checkbox-group",
                                {
                                  staticClass: "ksf-checkbox-grid",
                                  model: {
                                    value: _vm.idKidApply,
                                    callback: function ($$v) {
                                      _vm.idKidApply = $$v
                                    },
                                    expression: "idKidApply",
                                  },
                                },
                                _vm._l(item.students, function (kid) {
                                  return _c(
                                    "el-checkbox",
                                    {
                                      key: kid.idKid,
                                      staticClass: "ksf-checkbox-item",
                                      attrs: { label: kid.idKid },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "ksf-kid-name" },
                                        [_vm._v(_vm._s(kid.kidsName))]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          class: [
                                            "ksf-status-tag",
                                            _vm.getKidStatusClass(
                                              kid.statusKids
                                            ),
                                          ],
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.parseKidStatusVietnamese(
                                                  kid.statusKids
                                                )
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ])
                  : _c("div", { staticClass: "ksf-empty-state" }, [
                      _c("i", { staticClass: "el-icon-warning" }),
                      _c("span", [
                        _vm._v(
                          "Vui lòng chọn lớp để hiển thị danh sách học sinh"
                        ),
                      ]),
                    ]),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }